import plateLoaderGif from '@/assets/plate-loader.gif'
import styles from './PlateLoader.module.css'

interface PlateLoaderProps {
    // `fullscreen` pins the spinner at the exact viewport centre the bootstrap splash uses —
    // a transparent, click-through overlay — so when the splash hands off to a screen's own
    // loading state the spinner stays put (no jump into the content area) while the sidebar
    // stays visible. Without it the spinner renders inline, centred by its parent (used inside
    // the settings modals / admin panel).
    fullscreen?: boolean
}

// The single in-content loader. Renders the SAME branded plate spinner as the index.html
// bootstrap splash (identical asset + 32px), so the splash → content handoff reads as one
// continuous loader. The generic three-dot `Loader` stays only for the inline Button state,
// where it must adopt the button's `currentColor`.
const PlateLoader = ({ fullscreen }: PlateLoaderProps) => {
    const spinner = <img src={plateLoaderGif} width={32} height={32} alt="" />
    if (!fullscreen) return spinner
    return <div className={styles.fullscreen}>{spinner}</div>
}

export default PlateLoader
